/**
 * @flow
 * @relayHash a6d8827a5c75974f213a9990cc9a3de7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PayWithWorldpayInput = {|
  cancelPath: string,
  errorPath: string,
  failurePath: string,
  language?: ?string,
  orderId: string,
  pendingPath: string,
  successPath: string,
|};
export type PayWithWorldpayMutationVariables = {|
  input: PayWithWorldpayInput
|};
export type PayWithWorldpayMutationResponse = {|
  +payWithWorldpay: ?{|
    +order: ?{|
      +id: string,
      +orderid: ?string,
      +state: ?string,
      +payment: ?{|
        +state: ?string
      |},
    |},
    +redirectUrl: string,
  |}
|};
export type PayWithWorldpayMutation = {|
  variables: PayWithWorldpayMutationVariables,
  response: PayWithWorldpayMutationResponse,
|};
*/


/*
mutation PayWithWorldpayMutation(
  $input: PayWithWorldpayInput!
) {
  payWithWorldpay(input: $input) {
    order {
      id
      orderid
      state
      payment {
        state
        id
      }
    }
    redirectUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "PayWithWorldpayInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "orderid",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "redirectUrl",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PayWithWorldpayMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "payWithWorldpay",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PayWithWorldpayPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "payment",
                "storageKey": null,
                "args": null,
                "concreteType": "Payment",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PayWithWorldpayMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "payWithWorldpay",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "PayWithWorldpayPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "order",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "payment",
                "storageKey": null,
                "args": null,
                "concreteType": "Payment",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v2/*: any*/)
                ]
              }
            ]
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "PayWithWorldpayMutation",
    "id": null,
    "text": "mutation PayWithWorldpayMutation(\n  $input: PayWithWorldpayInput!\n) {\n  payWithWorldpay(input: $input) {\n    order {\n      id\n      orderid\n      state\n      payment {\n        state\n        id\n      }\n    }\n    redirectUrl\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '45e66477095e221463f5dbd962edb111';

module.exports = node;
